import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { MapComponent } from '../../mapComponent/map-Component.component';


@Component({
    selector: 'panic-details',
    templateUrl: './panic-details.component.html',

})
export class PanicDetailsComponent implements OnInit, AfterViewInit {
    @Input() isResolver: boolean;

    @Input() alertData: any;

    @Output() resolveForm: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild("panicMap") panicMap: MapComponent;

    address: string = null;

    constructor() { }

    ngOnInit() { }

    ngAfterViewInit() {
        var subscription = this.panicMap.Load$.subscribe((transporter: boolean) => {
            this.panicMap.setcenterMap(this.alertData.Longitude, this.alertData.Latitude);

            this.panicMap.AddFeature(this.alertData.Latitude, this.alertData.Longitude, "", this.alertData.PanicId, "/assets/img/map/dot.png","red");

            this.panicMap.GetMapAddress(this.alertData.Latitude, this.alertData.Longitude).then(data => {
                if (data) {
                    this.address = data
                }
                else {
                    this.address = null;
                }
            });
        });
           
       
    }

    openResolveForm() {
        this.resolveForm.emit(true);
    }

    randomNumberGenerator() {
        return (Math.random() * 100).toFixed(0);
    }

    updateMap() {
        this.panicMap.updateSize();
      
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/PanicAlert/panic-details/panic-details.component.ts